import { useEffect, useState } from 'react';
import { BREAKPOINT, DEVICE_TYPE } from '@constants/index';

interface sizeType {
    width: number;
    height: number;
};

interface resizeType extends sizeType {
    isPcWidth: boolean;
}

export const useResize = (): resizeType => {
    const [windowSize, setWindowSize] = useState({
        width: window?.innerWidth,
        height: window?.innerHeight
    });

    const handleResize = () => {
        setWindowSize({
            width: window?.innerWidth,
            height: window?.innerHeight
        })
    };

    useEffect(() => {
        window?.addEventListener('resize', handleResize);

        // unmount
        return () => window?.removeEventListener('resize', handleResize);
    }, []);

    return {...windowSize, isPcWidth: windowSize['width'] > 0 ? windowSize['width'] >= BREAKPOINT[DEVICE_TYPE.PC] : true};
};